/**
 * Live Google + Trustpilot reviews carousel.
 * Fetches /reviews from the calculator VPS and renders an auto-playing track.
 */
(function () {
  'use strict';

  function stars(n) {
    var full = Math.round(Number(n) || 0);
    if (full < 0) full = 0;
    if (full > 5) full = 5;
    return '★★★★★'.slice(0, full) + '☆☆☆☆☆'.slice(0, 5 - full);
  }

  function escapeHtml(s) {
    return String(s || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function formatScore(n) {
    if (n == null || n === '') return '-';
    var x = Number(n);
    return Number.isFinite(x) ? x.toFixed(1) : '-';
  }

  function relativeDate(iso) {
    if (!iso) return '';
    var t = Date.parse(iso);
    if (!Number.isFinite(t)) return '';
    var days = Math.round((Date.now() - t) / 86400000);
    if (days < 1) return 'Today';
    if (days === 1) return 'Yesterday';
    if (days < 30) return days + ' days ago';
    var months = Math.round(days / 30);
    if (months < 12) return months + ' month' + (months === 1 ? '' : 's') + ' ago';
    var years = Math.round(days / 365);
    return years + ' year' + (years === 1 ? '' : 's') + ' ago';
  }

  function sourceLabel(source) {
    return source === 'google' ? 'Google' : 'Trustpilot';
  }

  function cardHtml(review) {
    var when = relativeDate(review.date);
    return (
      '<article class="lr-card" data-source="' +
      escapeHtml(review.source) +
      '">' +
      '<div class="lr-card__top">' +
      '<span class="lr-card__stars" aria-label="' +
      escapeHtml(review.rating) +
      ' out of 5 stars">' +
      stars(review.rating) +
      '</span>' +
      '<span class="lr-card__source lr-card__source--' +
      escapeHtml(review.source) +
      '">' +
      escapeHtml(sourceLabel(review.source)) +
      '</span>' +
      '</div>' +
      (review.title
        ? '<h3 class="lr-card__title">' + escapeHtml(review.title) + '</h3>'
        : '') +
      '<blockquote class="lr-card__text">“' +
      escapeHtml(review.text) +
      '”</blockquote>' +
      '<footer class="lr-card__foot">' +
      '<span class="lr-card__author">' +
      escapeHtml(review.author) +
      '</span>' +
      (when ? '<span class="lr-card__when">' + escapeHtml(when) + '</span>' : '') +
      '</footer>' +
      '</article>'
    );
  }

  function init(root) {
    var api = root.getAttribute('data-api');
    var autoplayMs = Number(root.getAttribute('data-autoplay') || 5500);
    var track = root.querySelector('[data-lr-track]');
    var viewport = root.querySelector('[data-lr-viewport]');
    var dots = root.querySelector('[data-lr-dots]');
    var prevBtn = root.querySelector('[data-lr-prev]');
    var nextBtn = root.querySelector('[data-lr-next]');
    var filterBtns = root.querySelectorAll('[data-filter]');
    if (!api || !track) return;

    var allReviews = [];
    var filtered = [];
    var index = 0;
    var filter = 'all';
    var timer = null;
    var reducedMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function setScores(sources) {
      var g = root.querySelector('[data-lr-score="google"]');
      var t = root.querySelector('[data-lr-score="trustpilot"]');
      if (g && sources.google) {
        g.querySelector('[data-lr-value]').textContent = formatScore(sources.google.score);
        g.querySelector('[data-lr-meta]').textContent = '';
        if (sources.google.url) g.href = sources.google.url;
      }
      if (t && sources.trustpilot) {
        t.querySelector('[data-lr-value]').textContent = formatScore(sources.trustpilot.score);
        t.querySelector('[data-lr-meta]').textContent = '';
        if (sources.trustpilot.url) t.href = sources.trustpilot.url;
      }
    }

    function applyFilter() {
      filtered =
        filter === 'all'
          ? allReviews.slice()
          : allReviews.filter(function (r) {
              return r.source === filter;
            });
      if (!filtered.length) filtered = allReviews.slice();
      index = 0;
      render();
      restartAutoplay();
    }

    function render() {
      if (!filtered.length) {
        track.innerHTML =
          '<article class="lr-card"><p class="lr-card__text">Reviews are loading - please check back shortly.</p></article>';
        dots.innerHTML = '';
        return;
      }

      track.innerHTML = filtered.map(cardHtml).join('');
      dots.innerHTML = filtered
        .map(function (_, i) {
          return (
            '<button type="button" class="lr-dot' +
            (i === index ? ' is-active' : '') +
            '" data-lr-dot="' +
            i +
            '" aria-label="Go to review ' +
            (i + 1) +
            '"></button>'
          );
        })
        .join('');

      goTo(index, false);
    }

    function goTo(i, animate) {
      if (!filtered.length) return;
      index = ((i % filtered.length) + filtered.length) % filtered.length;
      var cards = track.children;
      var card = cards[index];
      if (!card) return;

      // Full-width slides: scroll each card flush to the viewport start.
      viewport.scrollTo({
        left: card.offsetLeft,
        behavior: animate === false || reducedMotion ? 'auto' : 'smooth',
      });

      Array.prototype.forEach.call(dots.querySelectorAll('.lr-dot'), function (dot, di) {
        dot.classList.toggle('is-active', di === index);
      });
      Array.prototype.forEach.call(cards, function (c, ci) {
        c.classList.toggle('is-active', ci === index);
      });
    }

    function next() {
      goTo(index + 1, true);
    }
    function prev() {
      goTo(index - 1, true);
    }

    function restartAutoplay() {
      if (timer) clearInterval(timer);
      if (reducedMotion || filtered.length < 2) return;
      timer = setInterval(next, autoplayMs);
    }

    filterBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        filter = btn.getAttribute('data-filter') || 'all';
        filterBtns.forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        applyFilter();
      });
    });

    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); restartAutoplay(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); restartAutoplay(); });
    dots.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-lr-dot]');
      if (!btn) return;
      goTo(Number(btn.getAttribute('data-lr-dot')), true);
      restartAutoplay();
    });

    root.addEventListener('mouseenter', function () {
      if (timer) clearInterval(timer);
    });
    root.addEventListener('mouseleave', restartAutoplay);
    root.addEventListener('focusin', function () {
      if (timer) clearInterval(timer);
    });
    root.addEventListener('focusout', restartAutoplay);

    // Touch / scroll snap sync - nearest full slide
    var scrollTimer = null;
    viewport.addEventListener('scroll', function () {
      if (scrollTimer) clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var cards = track.children;
        if (!cards.length) return;
        var best = Math.round(viewport.scrollLeft / Math.max(viewport.clientWidth, 1));
        if (best < 0) best = 0;
        if (best > cards.length - 1) best = cards.length - 1;
        index = best;
        Array.prototype.forEach.call(dots.querySelectorAll('.lr-dot'), function (dot, di) {
          dot.classList.toggle('is-active', di === index);
        });
        Array.prototype.forEach.call(cards, function (c, ci) {
          c.classList.toggle('is-active', ci === index);
        });
      }, 80);
    });

    fetch(api, { credentials: 'omit' })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (data) {
        allReviews = (data.reviews || []).filter(function (r) {
          return r && r.text;
        });
        setScores(data.sources || {});
        applyFilter();
        root.classList.add('is-ready');
      })
      .catch(function () {
        track.innerHTML =
          '<article class="lr-card"><p class="lr-card__text">We couldn’t load live reviews right now. ' +
          '<a href="https://uk.trustpilot.com/review/tradeengraving.co.uk" target="_blank" rel="noopener">See us on Trustpilot</a> ' +
          'or <a href="https://www.google.com/maps/place/Trade+Engraving" target="_blank" rel="noopener">Google</a>.</p></article>';
      });
  }

  function boot() {
    document.querySelectorAll('[data-live-reviews]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
